import { atom } from 'recoil'

import { PersonaType } from '@/modules/auth/domain/models/Persona'

type UserState = {
  companyId: string
  personaId: string
  personaType: PersonaType
  username: string
  userId: string
  userAvatar: string
  avatarName: string
}

import { AtomEffect } from 'recoil'

const localStorageEffect =
  (key: string): AtomEffect<UserState> =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue))
    }

    onSet((newValue, _, isReset) => {
      isReset
        ? localStorage.removeItem(key)
        : localStorage.setItem(key, JSON.stringify(newValue))
    })
  }

export const userState = atom({
  key: 'UserState',
  default: {
    companyId: '',
    personaId: '',
    personaType: 'THERAPIST',
    username: '',
    userId: '',
    userAvatar: '',
    avatarName: ''
  } as UserState,
  effects: [localStorageEffect('UserState')]
})
